export var TutorialSectionType;
(function (TutorialSectionType) {
    TutorialSectionType[TutorialSectionType["storyTimed"] = 0] = "storyTimed";
    TutorialSectionType[TutorialSectionType["storyInput"] = 1] = "storyInput";
    TutorialSectionType[TutorialSectionType["storyButton"] = 2] = "storyButton";
    TutorialSectionType[TutorialSectionType["gameInput"] = 3] = "gameInput";
    TutorialSectionType[TutorialSectionType["gameEvent"] = 4] = "gameEvent";
    TutorialSectionType[TutorialSectionType["gameButton"] = 5] = "gameButton";
})(TutorialSectionType || (TutorialSectionType = {}));
export var TutorialMessageColors;
(function (TutorialMessageColors) {
    TutorialMessageColors["red"] = "red";
    TutorialMessageColors["green"] = "green";
    TutorialMessageColors["blank"] = "blank";
})(TutorialMessageColors || (TutorialMessageColors = {}));
//# sourceMappingURL=index.js.map